import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'

const apiConst = {
  // 马甲包
  app_list: baseAPI + baseUrl + 'config/app/query',
  // 活动列表
  event_model_list: baseAPI + baseUrl + 'official/event/model/list',
  event_model_delete: baseAPI + baseUrl + 'official/event/model/delete',
  // 创建 / 修改
  event_model_create: baseAPI + baseUrl + 'official/event/model/create',
  event_model_update: baseAPI + baseUrl + 'official/event/model/update',
  // 其他
  event_rank_list: baseAPI + baseUrl + 'official/event/model/rank/data',
  export_event_rank_list: baseAPI + baseUrl + 'official/event/model/rank/data/download',
  // 复制活动配置
  copy_event_config: baseAPI + baseUrl + 'official/event/model/copy_to_create',
}

/**
 * @param {Object} params 参数 
 * @param {*} params.status 状态
 * @param {*} params.zoneOffset 时区
 * @param {*} params.valid 是否有效 -1ALL 0无效 1有效(默认)
 * @param {*} params.page 页码 每页10条
 * @returns 
 */
export const getActivityListReq = async (params) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.event_model_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...params
    }
  })
  return res
}

/**
 * @param { String } id id
 * @returns 
 */
export const deleteActivityListReq = async (info) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.event_model_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      id:info.id,
      eventCode:info.eventCode,
      operator:store.getters.username
    }
  })
  return res
}

/**
 * 获取排名列表
 * @param { String } eventCode 活动码
 * @returns 
 */
export const activityRankReq = async(eventCode) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.event_rank_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  })
  return res
}

/**
 * 导出排名数据
 * @param { String } eventCode 活动码
 * @returns 
 */
export const exportActivityRankReq = async(eventCode) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.export_event_rank_list,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob',
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  })
  return res
}


/**
 * 导出排名数据
 * @param { String } eventCode 活动码
 * @returns 
 */
export const copyActivityReq = async(eventCode) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.copy_event_config,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      eventCode
    }
  })
  return res
}

/**
 * 新增模板活动
 * @param { Object } data 创建的数据
 * @returns 
 */
export const addActivityReq = async(data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.event_model_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data:{
      ...data,
      operator:store.getters.username
    }
  })
  return res
}

/**
 * 编辑模板活动
 * @param { Object } data 编辑的数据
 * @returns 
 */
export const editActivityReq = async(data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.event_model_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data:{
      ...data,
      operator:store.getters.username
    }
  })
  return res
}
